module.exports = __webpack_public_path__ + "static/muziyoshiz-eabc0cf60a6828564c7321c5ac611971.png";